import { render, staticRenderFns } from "./afterSalesWorkOrder.vue?vue&type=template&id=bf0e6926&scoped=true"
import script from "./afterSalesWorkOrder.vue?vue&type=script&lang=js"
export * from "./afterSalesWorkOrder.vue?vue&type=script&lang=js"
import style0 from "./afterSalesWorkOrder.vue?vue&type=style&index=0&id=bf0e6926&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf0e6926",
  null
  
)

export default component.exports